export default __webpack_public_path__ + "static/media/alert-circle.8ec69ac9.svg";